import { render, staticRenderFns } from "./InvitationBanner.vue?vue&type=template&id=b4889408&scoped=true"
import script from "./InvitationBanner.vue?vue&type=script&lang=js"
export * from "./InvitationBanner.vue?vue&type=script&lang=js"
import style0 from "./InvitationBanner.vue?vue&type=style&index=0&id=b4889408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4889408",
  null
  
)

export default component.exports